(function($) {

  'use strict';

  function AjaxRepertory() {

    var self = this,

        $btnWrap = null,
        $wrap = null,
        $wrapAppend = null,
        $loader = null,

        url = '',
        action = '',
        wrapSelector = '',
        appendSelector = '',
        itemSelector = '',
        buttonSelector = '',
        loaderSelector = '',
        ajaxCallback = null,
        request = null,

        options = {
          'button': null,
          'wrap': null
        };

    /**
     * Load next articles and add them to dom
     * @param  {String} url [Next page url]
     */
    self.loadContent = function(data, type, pLoaderSelector) {
      var $loader = $(loaderSelector + pLoaderSelector),
          $btnWrap = $(buttonSelector);

      data.action = action;
      // Show loading
      if ($loader.length > 0) {
        $loader.fadeIn(500);
        $(document).trigger('onAjaxRepertoryLoader');
      }

      // Prevent mutliple ajax call for the same request
      if (request) { request.abort(); }


      // @todo: manage error from server
      request = $.get(url, data, function(response) {

        //add callback for custom implementation
        if(typeof ajaxCallback === 'function'){
           ajaxCallback(type, response);
           return;
         }

        if (!response.error) {
          var $response = $('<div />').append(response.content),
              $items = (type === 'replace') ? $response.find(wrapSelector) : $response.find(appendSelector);

          $items.find(itemSelector).hide().addClass('js-is-loading');

          if (type === 'replace') {
            $wrap.html($items.html());
          } else {
            var $button = $response.find(buttonSelector);
            $(appendSelector).append($items.html());

            // Update button (for next page url)
            $btnWrap.html($button.html());
          }

          $wrap.add(appendSelector).removeClass(loaderSelector).find(itemSelector).show().removeClass('js-is-loading');


          $(document).trigger('onAjaxRepertoryAppended');
        }
      }, 'json')
      .done( function() {
          $(buttonSelector).show();
      });
    };

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      url = options.url || '';
      action = options.action || '';
      wrapSelector = options.wrapSelector || '.js-article-wrap';
      appendSelector = options.appendSelector || '.js-article-append';
      itemSelector = options.itemSelector || '.js-article';
      buttonSelector = options.buttonSelector || '.js-btn-more';
      loaderSelector = options.loaderSelector || '.js-loader';
      ajaxCallback = options.ajaxCallback || null;

      $wrap = $(wrapSelector);

      window.cache.$document.on('click', buttonSelector + ' a', function(e) {
        e.preventDefault();
        $(buttonSelector).hide();
        $(buttonSelector).insertAfter('.js-items-wrapper');

        // Get content and add to DOM
        self.loadContent(Utils.parseURL($(this).attr('href')).query, null, '.is-button');
      });

    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.AjaxRepertory = AjaxRepertory;

}(jQuery));
